<ef-loading-container
    [observables]="[authorizations$, premiumPayService.entities$]"
    [loading]="premiumPayService.loading$"
></ef-loading-container>
<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-premium-pay
    [items]="premiumPays$ | async"
    [userAuths]="authorizations$ | async"
    [tasks]="tasks$ | async"
    [directReportsSelectItems]="directReportsSelectItems$ | async"
    [costTypesSelectItems]="costTypesSelectItems$ | async"
    [tasksSelectItems]="tasksSelectItems$ | async"
    [tasksFilterSelectItems]="TasksSubject.asObservable() | async"
    [alternateTasksSelectItems]="alternateTasksSelectItems$ | async"
    [usersSelectItems]="UsersSubject.asObservable() | async"
    [payrollItemsSelectItems]="payrollItemsSelectItems$ | async"
    [payrollItemsFilterSelectItems]="PayrollItemSubject.asObservable() | async"
    [serviceItemsSelectItems]="ServiceItemSubject.asObservable() | async"
    [selectedError]="selectedErrorWithStatus$ | async"
    (Filter)="onFilter($event)"
    (Save)="onSave($event)"
    (Delete)="onDelete($event)"
    (ShowError)="onShowError($event)"
></ef-premium-pay>
